export function request(id) {
    id = parseInt(id, 10);
    return {
        type: 'CUSTOMER_REQUEST_REACTIVATION_REQUEST',
        id
    };
}

export function finish(id, customer) {
    id = parseInt(id, 10);
    return {
        type: 'CUSTOMER_REQUEST_REACTIVATION_FINISH',
        id,
        customer
    };
}

export function error(id) {
    id = parseInt(id, 10);
    return {
        type: 'CUSTOMER_REQUEST_REACTIVATION_ERROR',
        id
    };
}
